// @ts-nocheck
import { FulfillmentMethod } from "@insite/client-framework/Services/SessionService";
import {
    chain,
    ChangeCustomerContext as BaseChangeCustomerContext,
} from "@insite/client-framework/Store/Components/AddressDrawer/Handlers/ApplyChanges";
import changeCustomerContext from "@insite/client-framework/Store/Context/Handlers/ChangeCustomerContext";
import { getLocationPathAndQuery } from "@insite/client-framework/Store/Data/Pages/PageSelectors";
import getIsB2BBillTo from "@store/Framework/Common/Utilities/getIsB2BBillTo";

import {
    createChainHandler,
    makeHandlerChainAwaitable,
    replaceInChain,
} from "@toolkit/Modules/client-framework/HandlerCreator";

export const ChangeCustomerContext = createChainHandler(
    "ChangeCustomerContext",
    chain,
    async ({ dispatch, getState, parameter: { onError } }) => {
        /* Store Custom Code - Start */
        const { selectedBillTo, selectedShipTo, isDefault, pickUpWarehouse } = getState().components.addressDrawer;
        let { fulfillmentMethod } = getState().components.addressDrawer;

        if (selectedBillTo && !getIsB2BBillTo(selectedBillTo)) {
            fulfillmentMethod = FulfillmentMethod.Ship;
        }
        /* Store Custom Code - End */

        const awaitableChangeCustomerContext = makeHandlerChainAwaitable(changeCustomerContext);

        await awaitableChangeCustomerContext({
            billToId: selectedBillTo?.id,
            shipToId: selectedShipTo?.id,
            fulfillmentMethod,
            pickUpWarehouse,
            isDefault,
            returnUrl: getLocationPathAndQuery(getState()),
            onError: (errorMessage: string) => {
                onError?.(errorMessage);
                dispatch({
                    type: "Components/AddressDrawer/CompleteApplyChanges",
                });
            },
        })(dispatch, getState);
    },
);

replaceInChain(chain, BaseChangeCustomerContext, ChangeCustomerContext);
